const templateUrl = require('./confirmation-dialog.html');

module.exports = angular.module('msi.modals.confirmation', [
  'ui.bootstrap'
]).name;

angular.module(module.exports)
  .service('dialogService', require('./confirmation-dialog.service'))
  .component('ogConfirmationDialog', {
    templateUrl: templateUrl,
    bindings: {
      resolve: '<',
      close: '&',
      dismiss: '&'
    }
  });
